module.exports = __webpack_public_path__ + "static/media/U1-T2-3-1a.5eef80d0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U1-T2-3-1a.svg
// module id = 568
// module chunks = 0